var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_764_4656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4613 26.5422L36.3333 40.4142V42.2835C36.3334 42.5531 36.2592 42.8175 36.1188 43.0477C35.9784 43.2779 35.7772 43.4649 35.5375 43.5882C35.2977 43.7115 35.0286 43.7664 34.7597 43.7467C34.4908 43.7271 34.2326 43.6337 34.0133 43.4768L25.24 37.2088H21.6666C20.9594 37.2088 20.2811 36.9279 19.781 36.4278C19.2809 35.9277 19 35.2494 19 34.5422V29.2088C19 28.5016 19.2809 27.8233 19.781 27.3232C20.2811 26.8231 20.9594 26.5422 21.6666 26.5422H22.4613ZM36.3333 21.4675V33.9902L37.8173 35.4742C37.6933 35.2366 37.6438 34.9672 37.6752 34.701C37.7066 34.4349 37.8174 34.1844 37.9933 33.9822L38.1106 33.8635C38.6573 33.3728 39 32.6648 39 31.8755C39.0002 31.193 38.7387 30.5364 38.2693 30.0408L38.1106 29.8875C37.851 29.6506 37.6953 29.3208 37.6775 28.9698C37.6598 28.6188 37.7814 28.2749 38.0158 28.0131C38.2502 27.7512 38.5786 27.5925 38.9295 27.5715C39.2803 27.5505 39.6253 27.6688 39.8893 27.9008C40.4484 28.4011 40.8958 29.0137 41.202 29.6986C41.5083 30.3835 41.6666 31.1253 41.6666 31.8755C41.6666 32.6258 41.5083 33.3676 41.202 34.0525C40.8958 34.7374 40.4484 35.3499 39.8893 35.8502C39.6873 36.0313 39.4348 36.1465 39.1655 36.1803C38.8963 36.2141 38.6232 36.165 38.3826 36.0395L40.3426 37.9995C40.3167 37.7863 40.3427 37.5699 40.4184 37.3689C40.4941 37.1678 40.6172 36.9881 40.7773 36.8448C41.4765 36.2195 42.036 35.4537 42.419 34.5974C42.802 33.7411 42.9999 32.8136 43 31.8755C43 29.9022 42.144 28.1288 40.7773 26.9062C40.645 26.7899 40.537 26.6486 40.4596 26.4904C40.3823 26.3321 40.337 26.1601 40.3265 25.9843C40.3159 25.8085 40.3403 25.6323 40.3983 25.466C40.4562 25.2997 40.5466 25.1465 40.664 25.0152C40.7815 24.884 40.9239 24.7774 41.0828 24.7014C41.2417 24.6255 41.4141 24.5819 41.59 24.573C41.766 24.5641 41.9419 24.5901 42.1077 24.6496C42.2735 24.7091 42.4258 24.8008 42.556 24.9195C43.5346 25.7949 44.3175 26.867 44.8535 28.0656C45.3895 29.2642 45.6666 30.5625 45.6666 31.8755C45.6666 33.1885 45.3895 34.4868 44.8535 35.6854C44.3175 36.8841 43.5346 37.9561 42.556 38.8315C42.4145 38.9583 42.2476 39.0534 42.0664 39.1104C41.8852 39.1674 41.6939 39.1851 41.5053 39.1622L43.6466 41.3035C43.8895 41.555 44.0239 41.8918 44.0209 42.2414C44.0178 42.591 43.8776 42.9254 43.6304 43.1726C43.3832 43.4198 43.0488 43.56 42.6992 43.5631C42.3496 43.5661 42.0128 43.4317 41.7613 43.1888L21.02 22.4488C20.8926 22.3259 20.791 22.1787 20.7212 22.0161C20.6513 21.8534 20.6145 21.6784 20.613 21.5014C20.6114 21.3243 20.6452 21.1488 20.7122 20.9849C20.7792 20.821 20.8782 20.6722 21.0034 20.547C21.1286 20.4218 21.2775 20.3228 21.4414 20.2558C21.6052 20.1887 21.7808 20.155 21.9578 20.1565C22.1349 20.1581 22.3098 20.1948 22.4725 20.2647C22.6352 20.3346 22.7823 20.4362 22.9053 20.5635L27.3666 25.0222L34.0146 20.2728C34.234 20.1163 34.4923 20.0232 34.7611 20.0038C35.0299 19.9844 35.2988 20.0394 35.5384 20.1629C35.778 20.2863 35.9789 20.4734 36.1191 20.7035C36.2593 20.9337 36.3335 21.198 36.3333 21.4675Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_764_4656",
    x: 3,
    y: 4,
    width: 58.6665,
    height: 55.7505,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.33333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_764_4656"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_764_4656",
    result: "effect2_dropShadow_764_4656"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_764_4656",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuted);
export default __webpack_public_path__ + "static/media/Muted.abe2d33d22c0a4d1296657840a9b741f.svg";
export { ForwardRef as ReactComponent };